import { useRouterContext } from "@pankod/refine-core";
import { Box } from "@pankod/refine-mui";

type TitleProps = {
    collapsed: boolean;
};

export const Title: React.FC<TitleProps> = ({ collapsed }) => {
    const { Link } = useRouterContext();

    return (
        <Link to="/">
            <Box
                sx={{
                    height: "72px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center"
                }}
            >
                { collapsed ? <h5>Streamer Studio</h5> : <h1>Streamer Studio</h1> }
            </Box>
        </Link>
    );
};
